import { evaluate } from 'mathjs';

export default {
  liittymismaksu(rakennustyyppi, tehontarve) {
    const categories = [
      {
        min: 0,
        max: 20,
        k1: 1.00,
        a: 2002,
        b: 75.10,
      },
      {
        min: 21,
        max: 80,
        k1: 1.00,
        a: 2002,
        b: 75.10,
      },
      {
        min: 81,
        max: 150,
        k1: 1.00,
        a: 2002,
        b: 75.10,
      },
      {
        min: 151,
        max: 10000000000000,
        k1: 1.00,
        a: 7009,
        b: 41.72
      },
    ];

    const kategoria = categories.find(c => tehontarve >= c.min && tehontarve <= c.max);
    kategoria.teho = tehontarve;
    return evaluate('k1 * (a + b * teho)', kategoria)
  },
  tehomaksu(rakennustyyppi, tehontarve) {
    const kategoriat = [
      {
        min: 0,
        max: 20,
        a: 589.33,
        b: 23.81,
      },
      {
        min: 21,
        max: 80,
        a: 318.24,
        b: 37.66,
      },
      {
        min: 81,
        max: 150,
        a: 595.22,
        b: 34.23,
      },
      {
        min: 151,
        max: 999999999,
        a: 3267.82,
        b: 16.52,
      },
    ];

    const kategoria = kategoriat.find(c => tehontarve >= c.min && tehontarve <= c.max);
    kategoria.teho = tehontarve;
    return evaluate('a + b * teho', kategoria);
  },
  energiamaksu(/*rakennustyyppi*/) {
    return 122.67;
  },
}
